import FullWidthLayout from "@/layouts/FullWidthLayout";
import DriversReport from "kinnect-front/KYard/Reports/Drivers/Report";
import { Pageable } from "kinnect-mixins";

export default {
	name: "YardDriversReportPage",

	metaInfo: { title: "Yard - Drivers Report" },

	mixins: [ Pageable ],

	render() {
		return <FullWidthLayout>
			<DriversReport></DriversReport>
		</FullWidthLayout>;
	}
};
